import { render, staticRenderFns } from "./ContactUsAcknowledge.vue?vue&type=template&id=40455962&"
import script from "./ContactUsAcknowledge.vue?vue&type=script&lang=js&"
export * from "./ContactUsAcknowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports